<template>
  <arrowBackIcon id="arrow-back"></arrowBackIcon>
</template>

<script>
  import arrowBackIcon from '../assets/arrow-back.svg'
  import vivus from 'vivus'

  export default {
    name: 'arrowBack',
    data() {
      return {
        timeoutPointer: false,
        anim: false
      }
    },
    props: {
      delay: {
        'type': Number,
        'default': 900
      },
      duration: {
        'type': Number,
        'default': 50
      }
    },
    mounted() {
      let anim = new vivus(this.$el, {
        start: 'manual', // avoid memory leak o scroll event
        duration: this.duration,
        animTimingFunction: vivus.EASE_IN,
      });
      this.anim = anim;
      anim.reset().stop();
      this.timeoutPointer = setTimeout(() => {
        try {
          anim.play();
        } catch (e) {
        }
      }, this.delay);

    },
    beforeDestroy() {
      clearTimeout(this.timeoutPointer);
      this.anim.stop().destroy();
    },
    components: {
      arrowBackIcon
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/arrowBack.vue